<!--
 * @Author: 汪俊洪
 * @Date: 2021-08-30 15:46:02
 * @LastEditors: 汪俊洪
 * @LastEditTime: 2023-02-28 15:13:56
 * @Description: 相关信息
-->
<template>
  <div class="app-table">
    <el-tabs v-model="status">
     <el-tab-pane name="3">
        <span slot="label">处理意见</span>
      </el-tab-pane>
      <el-tab-pane name="1">
        <span slot="label">流程图</span>
      </el-tab-pane>
      <el-tab-pane name="2">
        <span slot="label">附件</span>
      </el-tab-pane>
    </el-tabs>
    <div class="wrap" ref="diagram">
      <!-- 流程图 -->
      <Diagram :businessKey="businessKey" v-if="status === '1'" />
      <!-- 附件 -->
      <Enclosure
        :showUpload="showUpload"
        :isCC="isCC"
        :businessKey="businessKey"
        v-if="status === '2'"
      />
      <!-- 处理意见 -->
      <Comments :businessKey="businessKey" v-if="status === '3'" />
    </div>
  </div>
</template>

<script>
import Diagram from './diagram.vue'
import Enclosure from './enclosure.vue'
import Comments from './comments.vue'

export default {
  props: {
    showUpload: {
      type: Boolean,
      default: false
    },
    businessKey: {
      type: String,
      default: ''
    },
    isCC: {
      type: Boolean,
      default: false
    }
  },
  components: {
    Diagram,
    Enclosure,
    Comments
  },
  data () {
    return {
      status: '3'
    }
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
.wrap {
  min-height: 500px;
  background-color: #fff;
}
@media screen and (max-width: 800px) {
  .wrap {
    max-height: 100%;
    min-height: 0;
  }
}
</style>
